import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;

  justify-content: center;

  border-radius: 4px;

  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 12px;

  background-color: var(--color-background);
`;
export const Title = styled.div `
  margin-bottom: 4px;
  font-size: 12px;
  line-height: 1.3;
  color: ${Colors.GS600};
`;
